import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, debounce } from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getEmployeesList } from "redux/actions/EmployeesAction";
import { getBookingList } from "redux/actions/ReservationAction";
import { onLoaderTrigger } from "redux/actions/commonAction";
import CancelRegistrationModal from "components/cancelRegistrationModal/CancelRegistrationModal";
import useModal from "hooks/useModal";
import { getDateComparision, getDateFormat } from "utils/utils";
import FrontDeskTablist from "./FrontDeskTablist";
import { filterData, filterHistoryData } from "./FrontDeskData";
import "./FrontDesk.scss";
import { getRideDetails } from "redux/actions/UserDashboard";
import { approveEmployee } from "redux/actions/EmployeesAction";

const FrontDesk = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const startDate = searchParams?.get("startDate");
  const endDate = searchParams?.get("endDate");
  const filterPage = searchParams?.get("page");
  const filterRowsPerPage = searchParams?.get("rowsPerPage");
  const filterStatus = searchParams?.get("status");
  const filterSearch = searchParams?.get("search");

  let paramsList = {};
  searchParams.forEach((value, key) => {
    paramsList[key] = value;
  });

  const { tabs } = useParams();
  const navigate = useNavigate();

  // ----FormatingDate---
  const handleDateFormating = (data) => {
    return getDateFormat(data);
  };
  const [page, setPage] = useState(filterPage ? parseInt(filterPage) : 0);
  const [rowsPerPage, setRowsPerPage] = useState(filterRowsPerPage || 10);
  const [status, setStatus] = useState(
    filterStatus
      ? filterStatus?.split(",")
      : tabs === "all"
        ? []
        : tabs === "dashboard"
          ? []
          : "",
  );
  const [search, setSearch] = useState(filterSearch || "");
  const [dateFrom, setDateFrom] = useState(
    startDate && startDate !== "null"
      ? startDate
      : startDate === "null"
        ? ""
        : handleDateFormating(new Date()),
  );
  const [dateTo, setDateTo] = useState(
    endDate && endDate !== "null"
      ? endDate
      : endDate === "null"
        ? ""
        : handleDateFormating(new Date()),
  );
  const [tab, setTab] = useState(tabs ? tabs : "all");
  const { open: cancelModal, toggle: setCancelModal } = useModal();
  const [tripDetails, setTripDetails] = useState();

  const loaderBooking = useSelector((state) => state?.getBookingList?.loading);
  const employeesListTable = useSelector(
    (state) => state?.getEmployeesList?.employeesList?.data,
  );

  const bookingList = useSelector(
    (state) => state?.getBookingList?.bookingList?.data,
  );
  const profile =
    localStorage?.getItem("user") && JSON.parse(localStorage?.getItem("user"));

  const dashBorardUpperData = useSelector(
    (state) => state?.userRideDetails?.userRideDetails?.data?.body?.[0],
  );

  const companyID =
    localStorage.getItem("subCompany")?.length > 0 &&
    JSON.parse(localStorage.getItem("subCompany"));

  let payloadData = {
    search: search,
    page: page,
    pageSize: rowsPerPage,
    dateFrom: dateFrom ? dateFrom : "",
    dateTo: dateTo ? dateTo : "",
    status:
      tab === "history" && !status?.length
        ? "completed,cancelled"
        : tab === "all" && !status?.length
          ? ""
          : status,
    companyId: companyID?.value || "",
    tab: tab,
  };

  let EmployeePayloadData = {
    companyId: companyID?.value || "",
    search: search,
    page: page,
    pageSize: rowsPerPage,
    status: "",
  };

  let dashboardDetails = {
    dateFrom: dateFrom,
    dateTo: dateTo,
    companyId: companyID?.value || "",
  };

  useEffect(() => {
    if (tab === "employeeProfiles") {
      dispatch(getEmployeesList(EmployeePayloadData));
    } else if (tab === "billing") {
    } else if (tab === "dashboard") {
      const payload = {
        ...payloadData,
        status: "",
      };
      dispatch(getBookingList(payload));
      dispatch(getRideDetails(dashboardDetails));
    } else {
      const payload = {
        ...payloadData,
        status: status
          ? status
          : tab === "all" || tab === "dashboard"
            ? ""
            : "completed,cancelled",
      };
      dispatch(getBookingList(payload));
    }
    dispatch(onLoaderTrigger(false));
  }, []);

  const handleTab = (val) => {
    setSearchParams();
    navigate(`/front-desk/${val}`);
    setSearch("");
    setStatus([]);
    setTab(val);
    setPage(0);
    setRowsPerPage(10);
    setDateFrom(handleDateFormating(new Date()));
    setDateTo(handleDateFormating(new Date()));

    if (val === "employeeProfiles") {
      dispatch(
        getEmployeesList({
          ...EmployeePayloadData,
          search: "",
          pageSize: 10,
          page: 0,
        }),
      );
    } else if (val === "billing") {
    } else if (val === "dashboard") {
      const payload = {
        ...payloadData,
        status: "",
      };
      payloadData["dateTo"] = handleDateFormating(new Date());
      payloadData["dateFrom"] = handleDateFormating(new Date());
      dashboardDetails["dateTo"] = handleDateFormating(new Date());
      dashboardDetails["dateFrom"] = handleDateFormating(new Date());
      dispatch(getBookingList({ ...payloadData, status: "" }));
      dispatch(getRideDetails({ ...dashboardDetails }));
    } else {
      payloadData["search"] = "";
      payloadData["status"] = val === "all" ? "" : "completed,cancelled";
      payloadData["dateTo"] = handleDateFormating(new Date());
      payloadData["dateFrom"] = handleDateFormating(new Date());
      dispatch(getBookingList({ ...payloadData, pageSize: 10, page: 0 }));
    }
  };

  const onSearchQuery = debounce((val) => {
    setSearchParams({ ...paramsList, page: 0, search: val });
    setSearch(val);
    const payload =
      tab === "employeeProfiles"
        ? {
            ...EmployeePayloadData,
            search: val,
            pageSize: "",
            page: 0,
          }
        : { ...payloadData, search: val };
    handleCommonOnchange(payload);
  }, 500);

  const onSelectDateRange = (newValue) => {
    if (newValue === null || newValue === 0) {
      setSearchParams({
        ...paramsList,
        startDate: "null",
        endDate: "null",
        page: 0,
      });
      setDateFrom("");
      setDateTo("");
      payloadData = { ...payloadData, dateFrom: "", dateTo: "" };
      dashboardDetails = {
        ...dashboardDetails,
        dateFrom: "",
        dateTo: "",
      };
    } else {
      setSearchParams({
        ...paramsList,
        startDate: handleDateFormating(newValue[0]),
        endDate: handleDateFormating(newValue[1]),
        page: 0,
      });
      setDateFrom(handleDateFormating(newValue[0]));
      setDateTo(handleDateFormating(newValue[1]));
      payloadData = {
        ...payloadData,
        dateFrom: handleDateFormating(newValue[0]),
        dateTo: handleDateFormating(newValue[1]),
      };

      dashboardDetails = {
        ...dashboardDetails,
        dateFrom: handleDateFormating(newValue[0]),
        dateTo: handleDateFormating(newValue[1]),
      };
    }
    handleCommonOnchange(payloadData, dashboardDetails);
  };

  const onFilterChange = (filterValue) => {
    setStatus(filterValue);
    setSearchParams({
      ...paramsList,
      status: filterValue?.toString(),
      page: 0,
    });
    setPage(0);
    handleCommonOnchange({
      ...payloadData,
      page: 0,
      status:
        tab === "history" && !filterValue?.length
          ? "completed,cancelled"
          : filterValue?.toString(),
    });
  };

  const onRestFilter = () => {
    setSearchParams({ ...paramsList, status: "", page: 0 });
    handleCommonOnchange({
      ...payloadData,
      page: 0,
      status: tab === "all" ? "" : "completed,cancelled",
    });
    setPage(0);
    setStatus([]);
  };

  const handleChangePage = (event, newPage) => {
    setSearchParams({ ...paramsList, page: newPage });
    setPage(newPage);
    const payload =
      tab === "employeeProfiles"
        ? { ...EmployeePayloadData, page: newPage }
        : { ...payloadData, page: newPage };
    dashboardDetails = {
      ...dashboardDetails,
      dateFrom: "",
      dateTo: "",
    };
    handleCommonOnchange(payload, dashboardDetails);
  };

  const handleChangeRowsPerPage = (event) => {
    setSearchParams({
      ...paramsList,
      page: 0,
      rowsPerPage: parseInt(event.target.value),
    });
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    const payload =
      tab === "employeeProfiles"
        ? {
            ...EmployeePayloadData,
            page: 0,
            pageSize: parseInt(event.target.value),
          }
        : {
            ...payloadData,
            page: 0,
            pageSize: parseInt(event.target.value),
          };
    dashboardDetails = {
      ...dashboardDetails,
      dateFrom: "",
      dateTo: "",
    };
    handleCommonOnchange(payload, dashboardDetails);
  };

  const handleCommonOnchange = (payload, dashboardDetails) => {
    if (tab === "employeeProfiles") {
      dispatch(getEmployeesList(payload));
    } else if (tab === "dashboard") {
      dispatch(getBookingList(payload));
      dispatch(getRideDetails(dashboardDetails));
    } else {
      dispatch(getBookingList(payload));
    }
  };

  // ---MoreIcon---
  const onClickMoreIcon = (data, type) => {
    if (type?.toLowerCase() === "edit") {
      const dateStatus = getDateComparision(data?.scheduledTime);
      if (dateStatus) {
        navigate("/front-desk/new-booking", {
          state: {
            id: data?.id,
            page: "edit",
            branchName: data?.branchAddress,
          },
        });
      } else {
        toast.error("You are not allowed to edit the trip at this time");
      }
    } else if (type?.toLowerCase() === "request extension") {
      navigate("/front-desk/new-booking", {
        state: {
          id: data?.id,
          page: "extension",
          branchName: data?.branchAddress,
        },
      });
    } else {
      setCancelModal();
      setTripDetails(data);
    }
  };

  const onApproveEmployee = (row, status) => {
    dispatch(
      approveEmployee({
        companyId: row.companyId,
        employeeId: row.id,
        status,
        search,
        page,
        pageSize: rowsPerPage,
      }),
    );
  };

  const tablistProps = {
    page: page,
    rowsPerPage: rowsPerPage,
    employeesListTable: employeesListTable,
    bookingList: bookingList,
    filterData: filterData,
    status: status,
    filterHistoryData: filterHistoryData,
    tab: tab,
    search: search,
    setTab: setTab,
    handleTab: handleTab,
    onSearchQuery: onSearchQuery,
    onSelectDateRange: onSelectDateRange,
    handleChangePage: handleChangePage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    onFilterChange: onFilterChange,
    onRestFilter: onRestFilter,
    loaderBooking: loaderBooking,
    onClickMoreIcon: onClickMoreIcon,
    onApproveEmployee: onApproveEmployee,
    dateFrom: dateFrom,
    dateTo: dateTo,
    dashBorardUpperData: dashBorardUpperData,
  };

  return (
    <Box>
      <FrontDeskTablist {...tablistProps} />
      <CancelRegistrationModal
        open={cancelModal}
        toggle={setCancelModal}
        reservationData={tripDetails}
        payload={payloadData}
      />
    </Box>
  );
};

export default FrontDesk;
